import { render, staticRenderFns } from "./SithMesInventoryTransportApplicationList.vue?vue&type=template&id=3084b8b6&"
import script from "./SithMesInventoryTransportApplicationList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryTransportApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports